import React from "react";
import Story from "../components/About Me/Story";
import LeetCode from "../components/About Me/LeetCode";
import Github from "../components/About Me/Github";
import TabContainer from "../components/About Me/TabContainer";

function AboutMe() {
  return (
    <section>
      <div className="section__title" id="aboutMe">
        About Me
      </div>
      <div className="container">
        {/* Flex-Main */}
        <div className="flex flex-col md:flex-row w-screen  gap-2 md:gap-0">
          {/* flex box  1 */}
          <div className=" md:w-[160%]  ">
            {/*  flex box about me */}
            <div className="flex flex-col gap-2 w-full h-full ">
              <div className="section__content bg-containerColor dark:bg-darkContainerColor md:m-2 rounded-lg md:shadow-lg p-2 pb-4 ">
                <Story></Story>
              </div>
              <div className="bg-containerColor dark:bg-darkContainerColor md:h-full md:m-2 rounded-lg md:shadow-lg p-2">
                <TabContainer></TabContainer>
              </div>
            </div>
          </div>
          {/*  flexbox 2 */}
          <div className=" flex flex-col gap-2  w-full">
            <div className=" bg-containerColor dark:bg-darkContainerColor md:m-2 rounded-lg md:shadow-lg p-4 ">
              {/* leetcode staus */}
              <LeetCode></LeetCode>
            </div>
            {/* Github status */}
            <div className="flex flex-col h-full bg-containerColor dark:bg-darkContainerColor md:m-2 rounded-lg md:shadow-lg p-4 pb-0">
              <Github></Github>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutMe;
